export const Settlement = {
    LOADING_SETTLEMENT_LIST: "LOADING_SETTLEMENT_LIST",
    GET_SETTLEMENT_LIST: "GET_SETTLEMENT_LIST",
  };